import React from 'react';

import clsx from 'clsx';

import { ModalBody, ModalFooter, ModalHeader } from '@adeccoux/tag-ds';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import styles from './DocumentForSignatureDialog.module.scss';

interface NestedObjectListProps {
  isVisible: boolean;
  onSave: () => void;
  onCancel: () => void;
}

const DocumentForSignatureDialog: React.FC<NestedObjectListProps> = ({ isVisible, onSave, onCancel }) => (
  <Modal open={isVisible}>
    <Box className={clsx('tag-ds', styles.modal)}>
      <ModalHeader className={styles.modal__header}>
        <h4>Warning!</h4>
        <span className="material-icons" style={{ cursor: 'pointer' }} onClick={onCancel}>
          close
        </span>
      </ModalHeader>
      <ModalBody style={{ marginBottom: 48 }}>
        If you remove this document, you will permanently remove the Documents Validation step. This cannot be undone.
        Are you sure ?
      </ModalBody>
      <ModalFooter>
        <button className="button-secondary" onClick={onCancel}>
          No, skip changes
        </button>
        <button className="button" onClick={onSave}>
          Yes, Continue
        </button>
      </ModalFooter>
    </Box>
  </Modal>
);

export default DocumentForSignatureDialog;
